const PREFIX = 'workloop:rsvp-draft:';

const draftKey = (eventId, userId) => {
  if (!eventId || !userId) return null;
  return `${PREFIX}${eventId}:${userId}`;
};

export const loadRsvpDraft = (eventId, userId) => {
  const key = draftKey(eventId, userId);
  if (!key) return null;
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed;
  } catch {
    return null;
  }
};

export const saveRsvpDraft = (eventId, userId, draft) => {
  const key = draftKey(eventId, userId);
  if (!key || !draft) return;
  try {
    localStorage.setItem(key, JSON.stringify({
      guestCount: draft.guestCount,
      guests: draft.guests,
      customAnswers: draft.customAnswers || {},
      updatedAt: Date.now(),
    }));
  } catch {
    // ignore quota / private mode errors
  }
};

export const clearRsvpDraft = (eventId, userId) => {
  const key = draftKey(eventId, userId);
  if (!key) return;
  try {
    localStorage.removeItem(key);
  } catch {
    // ignore
  }
};

export const hasRsvpDraft = (eventId, userId) => {
  const draft = loadRsvpDraft(eventId, userId);
  if (!draft) return false;
  if (draft.guestCount && Number(draft.guestCount) > 0) return true;
  const guests = Array.isArray(draft.guests) ? draft.guests : [];
  const customAnswers = draft.customAnswers && typeof draft.customAnswers === 'object' ? draft.customAnswers : {};
  const hasCustom = Object.values(customAnswers).some((value) => String(value || '').trim());
  return guests.some((g) => g?.name?.trim() || g?.age || g?.foodPreference?.trim() || g?.drinkPreference) || hasCustom;
};
